import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/child_nondata_img.png'


const _withScopeId = n => (_pushScopeId("data-v-13daf131"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "header common_layout" }
const _hoisted_3 = { class: "center_flex_layout" }
const _hoisted_4 = {
  id: "qrcode",
  ref: "qrcode"
}
const _hoisted_5 = {
  key: 0,
  style: {"margin-top":"10px","font-size":"18px"}
}
const _hoisted_6 = {
  key: 0,
  class: "contents"
}
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "imgs" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"160px","height":"174px"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "boxText" }, "暫無數據", -1))
const _hoisted_11 = {
  key: 1,
  class: "mybox"
}
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "detail" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "商品明細", -1))
const _hoisted_15 = { class: "products" }
const _hoisted_16 = { class: "box" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  class: "right",
  style: {"margin-left":"5px"}
}
const _hoisted_20 = { class: "rightTop" }
const _hoisted_21 = { class: "common_font goods_name_hidden" }
const _hoisted_22 = { style: {"font-size":"12px"} }
const _hoisted_23 = { class: "guige" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  class: "goods",
  style: {"padding-top":"20px","border-top":"1px solid rgba(235, 238, 245, 1)","margin-top":"20px"}
}
const _hoisted_26 = { class: "left" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  class: "right",
  style: {"margin-left":"5px"}
}
const _hoisted_29 = { class: "rightTop" }
const _hoisted_30 = { class: "common_font goods_name_hidden" }
const _hoisted_31 = { style: {"font-size":"12px"} }
const _hoisted_32 = { class: "guige" }
const _hoisted_33 = { class: "footer" }
const _hoisted_34 = {
  class: "footerClild",
  style: {"margin-top":"10px"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footerText" }, "商品總金額", -1))
const _hoisted_36 = {
  style: {"flex":"1"},
  class: "footerprice"
}
const _hoisted_37 = { style: {"margin-left":"5px"} }
const _hoisted_38 = {
  class: "footerClild",
  style: {"border-top":"0"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footerText" }, "訂單總計", -1))
const _hoisted_40 = {
  style: {"color":"#409eff","height":"46px"},
  class: "footerprice"
}
const _hoisted_41 = { style: {"line-height":"48px"} }
const _hoisted_42 = { style: {"font-weight":"600","font-size":"18px","margin-left":"5px"} }

import { useRouter } from "vue-router";
import { get, post } from "../../utils/request";
import { ref, onMounted, reactive } from "vue";
// import TestCreateCode from "../../views/TestCreateCode.vue";
import { ElMessage } from "element-plus";
import QRCode from "qrcodejs2";
// import TestPay from "../../views/TestPay.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'buildOrder',
  setup(__props) {

const router = useRouter();
function goRouter() {
  router.push("/AddGoods");
}
const cartList = ref([]);
const showprice = ref(false);
const showdel = ref(false);
const showgoods = ref(false);
const showbtn = ref(true);
const showend = ref(false);
const packageData = ref('');

const getend = () => {
  router.replace("/ManagerHome");
};
const getList = () => {
  get("/manager/shopping/cart/list", null)
    .then((res: any) => {
      // console.log(JSON.stringify(res));
      if (res.code === 1) {
          showdel.value = true;
          showgoods.value = true;
          cartList.value = res.result;
          packageData.value = res.result.packageDto;
          // console.log(cartList.value);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
// 获取订单列表
onMounted(() => {
  showprice.value = false;
  showdel.value = false;
  showgoods.value = false;
  showbtn.value = true;
  showend.value = false;
  getList();
});
const open = () => {
  ElMessage({
    message: "删除成功",
    type: "success",
  });
};
// 生成支付二维码
const getPay = () => {
  const price = ref({
    price: cartList.totalPrice,
  });
  post(`/manager/order/create`, price.value, null)
    .then((res: any) => {
      if (res.code == 1) {
        showdel.value = false;
        showgoods.value = false;
        showprice.value = true;
        showbtn.value = false;
        showend.value = true;
        new QRCode("qrcode", {
          width: 200,
          height: 200,
          text: `https://api.sancttech.com/?state=${res.result.id}`,
        });
      }
      // router.push('/payingFail');
    })
    .catch((error) => {
      console.log(error);
    });
};
// 删除商品
const delate = (id: number) => {
  post(`/manager/shopping/cart/del?id=${id}`, null)
    .then((res: any) => {
      if (res.code == 1) {
        open();
        getList();
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TopHeader, { title: "創建訂單" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, null, 512),
        (showprice.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 應付金額:CNY " + _toDisplayString(cartList.value.totalPrice), 1))
          : _createCommentVNode("", true)
      ]),
      (cartList.value.goodsList == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", {
                  class: "addGoods",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goRouter()))
                }, "新增商品")
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (showgoods.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "addGoods",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (goRouter()))
                    }, " 添加商品 "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartList.value.goodsList, (item, goodsIn) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "goods",
                      style: _normalizeStyle({marginTop: goodsIn === 0 ? 0 : '20px'})
                    }, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("img", {
                          src: item.goodsImg,
                          alt: ""
                        }, null, 8, _hoisted_18)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(item.goodsName), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(cartList.value.currency), 1),
                            _createElementVNode("span", null, _toDisplayString(item.goodsPrice), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", null, _toDisplayString(item.skuName), 1),
                          _createElementVNode("div", null, "x" + _toDisplayString(item.num), 1)
                        ])
                      ]),
                      (showdel.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"display":"flex","align-items":"center"},
                            onClick: ($event: any) => (delate(item.id))
                          }, [
                            _createVNode(_component_el_icon, { color: "#FF7575" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_24))
                        : _createCommentVNode("", true)
                    ], 4))
                  }), 128)),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("img", {
                        src: packageData.value.goodsImg,
                        alt: ""
                      }, null, 8, _hoisted_27)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(packageData.value.goodsName), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(cartList.value.currency), 1),
                          _createElementVNode("span", null, _toDisplayString(packageData.value.goodsPrice), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", null, _toDisplayString(packageData.value.skuName), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", null, _toDisplayString(cartList.value.currency), 1),
                  _createElementVNode("span", _hoisted_37, _toDisplayString(cartList.value.goodsPrice), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(cartList.value.currency), 1),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(cartList.value.totalPrice), 1)
                ])
              ])
            ]),
            (showbtn.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "twoCode",
                  onClick: getPay,
                  style: {"position":"absolute","bottom":"28px","left":"0","right":"0"}
                }, " 生成支付二維碼 "))
              : _createCommentVNode("", true),
            (showend.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "twoCode",
                  onClick: getend,
                  style: {"position":"absolute","bottom":"28px","left":"0","right":"0"}
                }, " 完成 "))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}
}

})